import { formatARS, type BulkPriceChangeDto } from '@gl/shared';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { formatPct, pctOf } from './format';

export function PreviewTable({ changes, avgDeltaPct }: { changes: BulkPriceChangeDto[]; avgDeltaPct: number }) {
  const totalOld = changes.reduce((a, c) => a + c.oldPriceCents, 0);
  const totalNew = changes.reduce((a, c) => a + c.newPriceCents, 0);
  return (
    <div className="max-h-[55vh] overflow-y-auto rounded-md border">
      <Table>
        <TableHeader className="sticky top-0 z-10 bg-background">
          <TableRow>
            <TableHead>Producto</TableHead>
            <TableHead className="text-right">Antes</TableHead>
            <TableHead className="text-right">Después</TableHead>
            <TableHead className="text-right">Δ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {changes.map((c) => {
            const pct = pctOf(c.oldPriceCents, c.newPriceCents);
            return (
              <TableRow key={`${c.targetType}:${c.id}`}>
                <TableCell className="max-w-[12rem] whitespace-normal sm:max-w-none">
                  <span className={cn(c.targetType === 'VARIANT' && 'text-muted-foreground')}>{c.name}</span>
                </TableCell>
                <TableCell className="text-right text-muted-foreground tabular-nums line-through decoration-muted-foreground/40">
                  {formatARS(c.oldPriceCents)}
                </TableCell>
                <TableCell className="text-right font-medium tabular-nums">{formatARS(c.newPriceCents)}</TableCell>
                <TableCell
                  className={cn(
                    'text-right tabular-nums',
                    pct !== null && pct > 0 && 'text-success',
                    pct !== null && pct < 0 && 'text-destructive',
                  )}
                >
                  {formatPct(pct)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter className="sticky bottom-0 bg-muted">
          <TableRow>
            <TableCell className="font-medium">
              {changes.length === 1 ? '1 precio' : `${changes.length} precios`}
            </TableCell>
            <TableCell className="text-right tabular-nums">{formatARS(totalOld)}</TableCell>
            <TableCell className="text-right font-medium tabular-nums">{formatARS(totalNew)}</TableCell>
            <TableCell className="text-right tabular-nums" title="Variación promedio">
              {formatPct(avgDeltaPct)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  );
}
